// extracted by mini-css-extract-plugin
export default {"icon":"ChevronLeft_icon__K3767"};